import React, { useEffect, useRef } from 'react';
import { forwardRef, useImperativeHandle } from 'react';
import CallApi from '../apiConnect/CallApi';
import { CallConfirmDialog, glbGetLocalStorage, showAlert } from './GlobalFunctions';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AuthBaseURL, GatewayURL } from "../apiConnect/config";
import axios from 'axios';
import SterStaticLabel from '../userctrls/SterCtrls/SterStaticLabel';
const OreChangePassword = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        fnSaveChangePwd() {
            return fnSaveChangePwd();
        },
        fnAddMode() {
            return fnAddMode();
        }
    }));
    const refChagePwdDet = useRef([]);
    const refOldPwd = 1;
    const refNewPwd = 2;
    const refConfirmPwd = 3;
    let refAppSetgConfig = useRef(glbGetLocalStorage("appsett"));
    let lnResetPwd = 'Your password has been reset. To proceed, please update your password and log in again.';
    let lnNewPwd = 'As you are logging in for the first time, please take a moment to set your new password.';
    let propsjsondesigndata = [];
    propsjsondesigndata[refOldPwd] = { "crntID": refOldPwd, "className": "sterInputText", "name": "oldpwd", "caption": "Old Password", "value": "", "datasource": '', "visible": true, "ctrlcode": "WFC013", "placeholder": "", "disabled": false, "style": "", "showmsg": true, "required": true };
    propsjsondesigndata[refNewPwd] = { "crntID": refNewPwd, "className": "sterInputText", "name": "newpwd", "caption": "New Password", "value": "", "datasource": '', "visible": true, "ctrlcode": "WFC013", "placeholder": "", "disabled": false, "style": "", "showmsg": true, "required": true };
    propsjsondesigndata[refConfirmPwd] = { "crntID": refConfirmPwd, "className": "sterInputText", "name": "cfmpwd", "caption": "Confirm Password", "value": "", "datasource": '', "visible": true, "ctrlcode": "WFC013", "placeholder": "", "disabled": false, "style": "", "showmsg": true, "required": true };

    function fnAddMode() {
        if (props.scrmode === undefined || (props.scrmode !== undefined && props.scrmode !== "login")) {
            refChagePwdDet.current[refOldPwd].value = '';
        }
        refChagePwdDet.current[refNewPwd].value = '';
        refChagePwdDet.current[refConfirmPwd].value = '';
    }

    function fnSaveChangePwd() {
        let lnPwdCharacter = 6;
        if (refAppSetgConfig.current !== undefined && refAppSetgConfig.current.length > 0 && refAppSetgConfig.current[0].as !== undefined
            && refAppSetgConfig.current[0].as.pwt !== undefined && refAppSetgConfig.current[0].as.pwt === 'md') {
            lnPwdCharacter = 8;
        }
        let lnSOldPwd = 0;
        if ((props.scrmode !== undefined && props.scrmode !== "login" && refChagePwdDet.current[refOldPwd] !== undefined) || (props.scrmode === undefined && refChagePwdDet.current[refOldPwd] !== undefined)) {
            lnSOldPwd = refChagePwdDet.current[refOldPwd].value;
            if (lnSOldPwd === null || lnSOldPwd === undefined) { lnSOldPwd = '' };
        }
        let lnSNewPwd = refChagePwdDet.current[refNewPwd].value;
        if (lnSNewPwd === null || lnSNewPwd === undefined) { lnSNewPwd = '' };
        let lnSConfirmPwd = refChagePwdDet.current[refConfirmPwd].value;
        if (lnSConfirmPwd === null || lnSConfirmPwd === undefined) { lnSConfirmPwd = '' };
        if (lnSOldPwd === '' || (props.scrmode !== undefined && props.scrmode !== "login")) {
            showAlert("Please Fill Current Password..!!", 'error');
        } else if (lnSNewPwd === '') {
            showAlert("Please Fill New Password..!!", 'error');
        } else if (lnSConfirmPwd === '') {
            showAlert("Please Fill Confirm Password..!!", 'error');
        } else if (lnSNewPwd.length < lnPwdCharacter) {
            showAlert(`The password should be at least ${lnPwdCharacter} characters long..!!!`, 'error');
        } else if (lnSNewPwd !== '' && lnSConfirmPwd !== '' && (lnSNewPwd !== lnSConfirmPwd)) {
            showAlert("Confirm password doesn't match New password..!!", 'error');
        } else if (lnSNewPwd === lnSOldPwd) {
            showAlert("The new password cannot be the same as the current password..!!", 'error');
        } else if ((refAppSetgConfig.current !== undefined && refAppSetgConfig.current.length > 0 && refAppSetgConfig.current[0].as !== undefined
            && refAppSetgConfig.current[0].as.pwt !== undefined && refAppSetgConfig.current[0].as.pwt === 'md') && !fnValidate(lnSNewPwd)) {
            showAlert("Password should be at least 8 characters in length and should meet the following conditions,At least one one number & one special character (Ex:@#$%),At least one lower & one upper case letter", 'error');
        } else {
            fnUpdateChangePwd();
        }
    }

    async function fnUpdateChangePwd() {
        let lnSOldPwd = "";
        if (props.scrmode === undefined || (props.scrmode !== undefined && props.scrmode !== "login")) {
            lnSOldPwd = refChagePwdDet.current[refOldPwd].value;
        }
        let lnSNewPwd = refChagePwdDet.current[refNewPwd].value;
        let lnUserData = glbGetLocalStorage("ssUserData");
        let lnUserCode = lnUserData.usercode;
        let lsScreenMode = props.scrmode !== undefined && props.scrmode === "login" ? "loginpge" : "changepwd";
        //let loResponse = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 1969, ver: -1, alias: "RfTHTtg96p", lparams: { "pnUserCode": lnUserCode, "psOldPassword": lnSOldPwd, "psNewPassword": lnSNewPwd } }, toa: 'u' });
        let loResponse = await CallApi({
            method: "post", lookup: "Authentication/ChangePassword", body: {
                "pnUserCode": lnUserCode,
                "psOldPassword": lnSOldPwd,
                "psNewPassword": lnSNewPwd,
                "psScrMode": lsScreenMode
            }, toa: 'g'
        });
        if (loResponse.status === true) {
            // showAlert(loResponse.data, 'success');
            try {
                let lsGatewayURL = GatewayURL;
                let lsAuthURL = AuthBaseURL;
                let lsRefreshToken = await glbGetLocalStorage("refreshtoken");
                let lsAccessToken = await glbGetLocalStorage("accesstoken");
                let loconfig = await glbGetLocalStorage("config");
                if (loconfig !== undefined && loconfig !== null) {
                    if (loconfig.hasOwnProperty("gatewayurl")) {
                        lsGatewayURL = loconfig.gatewayurl;
                    }
                    if (loconfig.hasOwnProperty("authbaseurl")) {
                        lsAuthURL = loconfig.authbaseurl;
                    }
                }
                let loRefreshTokenHeader = { "Content-Type": "application/json", "Authorization": "Bearer " + lsAccessToken, "toa": "g", "RefreshToken": lsRefreshToken };
                const tknresponse = await axios.post(lsGatewayURL + lsAuthURL + "Authentication/TenantLogout", "", { headers: loRefreshTokenHeader });
            } catch (error) {
                console.error("change password logout", error)
            }
            CallConfirmDialog("success", "Your password has been updated successfully.Kindly relogin with the new password!!.", () => fnClose("aftersave"));

            //fnUpdateStageDB();
        } else {
            showAlert(loResponse.errmsg, 'error');
        }
    }

    function fnClose(pstype) {
        props.dialogclose(pstype);
    }

    async function fnUpdateStageDB() {
        let lnSOldPwd = refChagePwdDet.current[refOldPwd].value;
        let lnSNewPwd = refChagePwdDet.current[refNewPwd].value;
        let lnUserData = glbGetLocalStorage("ssUserData");
        let lnUserCode = lnUserData.usercode;
        let loResponse = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 1969, ver: -1, alias: "GQkRFm1bHv", lparams: { "pnUserCode": lnUserCode, "psOldPassword": lnSOldPwd, "psNewPassword": lnSNewPwd } }, toa: 'o' });
        if (loResponse.status === true && loResponse.data[0].code === 10) {
            setTimeout(() => {
                props.dialogclose();
            }, 2000);

        }
    }

    function fnPassWordShow(psstat) {
        if (refChagePwdDet.current[psstat] !== undefined && refChagePwdDet.current[psstat] !== null) {
            //    refChagePwdDet.current[psstat].datatype = refChagePwdDet.current[psstat].datatype === 'text' ? 'password' : 'text';
            //    if(refChagePwdDet.current[psstat].className==='e-hidepassword') {

            //    }
            refChagePwdDet.current[psstat].className = refChagePwdDet.current[psstat].className === 'e-input e-hidepassword' ? 'e-input e-showpassword' : 'e-input e-hidepassword';
            // refChagePwdDet.current[psstat].classList.remove('e-hidepassword')

            if (psstat === 2) {
                document.getElementById('newpwd').className = refChagePwdDet.current[psstat].className === 'e-input e-hidepassword' ? "e-input-group-icon far fa-eye-slash" : 'e-input-group-icon far fa-eye';
            } else {
                document.getElementById('cnfrpwd').className = refChagePwdDet.current[psstat].className === 'e-input e-hidepassword' ? "e-input-group-icon far fa-eye-slash" : 'e-input-group-icon far fa-eye';
            }
        }
    }

    function fnValidateError(e) {
        let lsval = e.target !== undefined && e.target.value !== null ? e.target.value : "";
        if (refAppSetgConfig.current !== undefined && refAppSetgConfig.current.length > 0 && refAppSetgConfig.current[0].as !== undefined
            && refAppSetgConfig.current[0].as.pwt !== undefined && refAppSetgConfig.current[0].as.pwt === 'md') {
            let lsValidate = fnValidate(lsval);
            if (!lsValidate && lsval !== "") {
                document.getElementById('diverrmsg').classList.remove('d-none');
                document.getElementById('diverrmsg').classList.add('invalid-feedback');
            } else {
                document.getElementById('diverrmsg').classList.add('d-none');
                document.getElementById('diverrmsg').classList.remove('invalid-feedback');
            }
        }
    }

    function fnValidate(psval) {
        const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        return regex.test(psval);
    }

    return (
        <React.Fragment>
            <div className="ost-change-password-container">
                <div className='ost-change-password-header p-0 text-center p-3 pb-0'>
                    <div className='ost-ch-pass-icon'>
                        <span className='ost-ch-pass-icon-rotate'><i className="fas fa-star-of-life"></i></span>
                        <span className='ost-ch-pass-icon-rotate ani2'><i className="fas fa-circle"></i></span>
                        <span className='lock-ic'><i className="fad fa-unlock-alt"></i></span>
                    </div>
                    <h4 className='fs-20 font-weight-600 my-3 mb-3'>Change Password</h4>
                </div>
                <div className='ost-change-password-content p-4 pt-0'>
                    <div className="row">
                        <div className="col-md-12">
                            {
                                props.scrmode !== undefined && props.scrmode === "login" ? <h6 className='fs-13 text-center mb-3'>{props.logtype === 1 ? lnResetPwd : lnNewPwd}</h6> :
                                    <div className='row'>
                                        <div className="col-md-12 mb-2">
                                            <SterStaticLabel custom={{ "caption": "Current Password", "required": true, "class": "" }} />
                                            {/* <TextBoxComponent ref={el => refChagePwdDet.current[refOldPwd] = el} className="e-input" type="text" /> */}
                                            <div className="e-input-group e-input-copypasenotwlloed" >
                                                <input id="changeps_oldps" className="e-input e-hidepassword" ref={el => refChagePwdDet.current[refOldPwd] = el} type="text" />
                                                {/* <span id='newpwd' className="e-input-group-icon far fa-eye-slash" onClick={() => { fnPassWordShow(refOldPwd) }} ></span> */}
                                            </div>
                                        </div>
                                    </div>
                            }
                            <div className='row'>
                                <div className="col-md-12 mb-2 position-relative">
                                    <SterStaticLabel custom={{ "caption": "New Password", "required": true, "class": "" }} />
                                    <div className="e-input-group e-input-copypasenotwlloed">
                                        <input id="changeps_newps" className="e-input e-hidepassword" ref={el => refChagePwdDet.current[refNewPwd] = el} type="text" onChange={(e) => { fnValidateError(e) }} />
                                        <span id='newpwd' className="e-input-group-icon far fa-eye-slash" onClick={() => { fnPassWordShow(refNewPwd) }} ></span>
                                    </div>
                                    <div id='diverrmsg' style={{ display: 'block' }} className="d-none ost-invalid-suggeestion">
                                        <p className="m-0 mb-1">1,Password should be at least 8 characters in length and should meet the following conditions</p>
                                        <p className="m-0 mb-1">2,At least one number & one special character (Ex:@#$%)</p>
                                        <p className="m-0">3,At least one lower & one upper case letter</p>
                                    </div>
                                    {/* <TextBoxComponent ref={el => refChagePwdDet.current[refNewPwd] = el} className="e-input" type="password" /> */}
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-12 mb-2">                       
                                    <SterStaticLabel custom={{ "caption": "Confirm Password", "required": true, "class": "" }} />
                                    <div className="e-input-group e-input-copypasenotwlloed">
                                        <input id="changeps_confps" className="e-input  e-hidepassword" ref={el => refChagePwdDet.current[refConfirmPwd] = el} type="text" />
                                        <span id='cnfrpwd' className="e-input-group-icon far fa-eye-slash" onClick={() => { fnPassWordShow(refConfirmPwd) }} ></span>
                                    </div>
                                    {/* <TextBoxComponent ref={el => refChagePwdDet.current[refConfirmPwd] = el} className="e-input" type="password" /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
)
export default OreChangePassword;